import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Megaphone, Gift } from 'lucide-react';
import KanbanBoard from '../components/KanbanBoard';
import { useKanban } from '../hooks/useKanban';

export default function KanbanPage() {
  const { appointments, handleUpdateKanbanStatus } = useKanban();
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 border-b border-seryi-bg-light/80 pb-4">
        <div>
          <h2 className="text-xl font-extrabold text-seryi-heading">CRM Kanban</h2>
          <p className="text-xs text-seryi-text">Gestiona visualmente el estado de tus leads y citas (Drag & Drop).</p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <button
            onClick={() => navigate('/v2/marketing')}
            className="px-4 py-2.5 bg-seryi-green text-seryi-bg-dark hover:brightness-110 rounded-2xl text-xs font-extrabold transition-all shadow-md flex items-center gap-2"
          >
            <Megaphone size={16} />
            <span>Campañas WhatsApp</span>
          </button>
          <button
            onClick={() => navigate('/v2/fidelizacion')}
            className="px-4 py-2.5 bg-amber-500 text-slate-900 hover:brightness-110 rounded-2xl text-xs font-extrabold transition-all shadow-md flex items-center gap-2"
          >
            <Gift size={16} />
            <span>Cupones & VIP</span>
          </button>
        </div>
      </div>
      <KanbanBoard 
        appointments={appointments} 
        onUpdateStatus={handleUpdateKanbanStatus} 
      />
    </div>
  );
}
